import { apiRequest } from "./api";

const firstError = (value) => {
  if (Array.isArray(value)) return value.map(firstError).filter(Boolean).join(" ");
  if (value && typeof value === "object") return Object.values(value).map(firstError).filter(Boolean).join(" ");
  return value == null ? "" : String(value);
};

export async function videoInterviewRequest(path, options = {}) {
  const response = await apiRequest(path, options);
  const data = response.status === 204 ? null : await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.detail || firstError(data) || `Request failed (${response.status}).`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}

export const humanVideoStatus = (value) => String(value || "").replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

export const recommendationColor = {
  potential_match: "green",
  ready_for_human_review: "blue",
  more_information_required: "orange",
  request_video_retake: "red",
  insufficient_evidence: "default",
};
